import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WaveAnnouncement } from '@/components/game/waves/WaveManager';

/**
 * Interface for announcement state
 */
interface AnnouncementState {
  waveAnnouncement: WaveAnnouncement | null;
}

/**
 * Initial announcement state
 */
const initialState: AnnouncementState = {
  waveAnnouncement: null
};

/**
 * Announcement slice for Redux
 */
const announcementSlice = createSlice({
  name: 'announcement',
  initialState,
  reducers: {
    /**
     * Sets the current wave announcement
     */
    setWaveAnnouncement: (state, action: PayloadAction<WaveAnnouncement>) => {
      state.waveAnnouncement = action.payload;
    },
    
    /**
     * Clears the current wave announcement
     */
    clearWaveAnnouncement: (state) => {
      state.waveAnnouncement = null;
    }
  }
});

export const { setWaveAnnouncement, clearWaveAnnouncement } = announcementSlice.actions;
export default announcementSlice.reducer; 